<template>
  <p v-if="hasDiscountedPrice" class="heading-xxs strike-through w-fit">
    <span aria-hidden="true">{{ plan?.RegularMonthlyFee }}</span>
    <span class="sr-only">
      {{ `Tidigare ${plan?.RegularMonthlyFee} kronor, nu ` }}
    </span>
  </p>

  <p
    v-if="plan?.MonthlyFee"
    :class="hasDiscountedPrice ? 'text-text-success' : ''"
    class="heading-xs"
  >
    <span aria-hidden="true">{{ plan?.MonthlyFee }} kr/mån</span>
    <span class="sr-only">{{ plan?.MonthlyFee }} kronor i månaden</span>
  </p>
</template>

<script lang="ts" setup>
import type { AggregatedPlanDto } from '~/models/ListingProduct.api.model';

interface Props {
  plan?: AggregatedPlanDto;
}

const props = defineProps<Props>();

const hasDiscountedPrice = computed(
  () =>
    props.plan?.RegularMonthlyFee &&
    props.plan?.RegularMonthlyFee !== props.plan?.MonthlyFee,
);
</script>
